<section class="space-y-6">
  <div class="flex flex-wrap items-center justify-between gap-4">
    <div>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        Reservas creadas desde tu sitio web público o asistente IA. Estas reservas se crean automáticamente confirmadas.
      </p>
    </div>
    <div class="flex gap-2">
      <button
        class="rounded-full px-4 py-2 text-sm font-medium border border-gray-200 text-gray-700 dark:text-gray-100 dark:border-dark-600 hover:bg-gray-100 dark:hover:bg-dark-700/60"
        [ngClass]="{'bg-brand-100 text-brand-700 dark:bg-brand-500/20 dark:text-brand-50 border-brand-200 dark:border-brand-500/60': selectedOrigin() === 'all'}"
        (click)="filterByOrigin('all')">
        Todas
      </button>
      <button
        class="rounded-full px-4 py-2 text-sm font-medium border border-gray-200 text-gray-700 dark:text-gray-100 dark:border-dark-600 hover:bg-gray-100 dark:hover:bg-dark-700/60"
        [ngClass]="{'bg-brand-100 text-brand-700 dark:bg-brand-500/20 dark:text-brand-50 border-brand-200 dark:border-brand-500/60': selectedOrigin() === 'Website'}"
        (click)="filterByOrigin('Website')">
        Sitio web
      </button>
      <button
        class="rounded-full px-4 py-2 text-sm font-medium border border-gray-200 text-gray-700 dark:text-gray-100 dark:border-dark-600 hover:bg-gray-100 dark:hover:bg-dark-700/60"
        [ngClass]="{'bg-brand-100 text-brand-700 dark:bg-brand-500/20 dark:text-brand-50 border-brand-200 dark:border-brand-500/60': selectedOrigin() === 'AiAgent'}"
        (click)="filterByOrigin('AiAgent')">
        Asistente IA
      </button>
    </div>
  </div>

  <div
    class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm dark:border-dark-600 dark:bg-dark-800">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200 text-sm dark:divide-dark-600">
        <thead class="bg-gray-50 dark:bg-dark-700/40">
          <tr>
            <th class="px-6 py-3 text-left font-semibold text-gray-600 dark:text-gray-300 dark:bg-gray-900/90">Fecha y hora
            </th>
            <th class="px-6 py-3 text-left font-semibold text-gray-600 dark:text-gray-300 dark:bg-gray-900/90">Cliente
            </th>
            <th class="px-6 py-3 text-left font-semibold text-gray-600 dark:text-gray-300 dark:bg-gray-900/90">Servicio
            </th>
            <th class="px-6 py-3 text-left font-semibold text-gray-600 dark:text-gray-300 dark:bg-gray-900/90">Profesional
            </th>
            <th class="px-6 py-3 text-left font-semibold text-gray-600 dark:text-gray-300 dark:bg-gray-900/90">Origen
            </th>
            <th class="px-6 py-3 text-left font-semibold text-gray-600 dark:text-gray-300 dark:bg-gray-900/90">Estado
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-x divide-gray-200 dark:divide-dark-800">
          @if (isLoading()) {
          <tr class="text-gray-700 dark:bg-gray-800 dark:text-gray-100">
            <td colspan="6" class="px-6 py-6 text-center text-sm text-gray-500 dark:text-gray-300">
              Cargando reservas...
            </td>
          </tr>
          } @else if (!filteredEvents().length) {
          <tr class="text-gray-700 dark:bg-gray-800 dark:text-gray-100">
            <td colspan="6" class="px-6 py-6 text-center text-sm text-gray-500 dark:text-gray-300">
              No hay reservas externas en este momento.
            </td>
          </tr>
          } @else {
          @for (event of filteredEvents(); track event.eventId) {
          <tr class="text-gray-700 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-900">
            <td class="px-6 py-4">
              <p class="font-medium dark:text-gray-400">
                {{ event.startDate | date:'MMM d, y' }}
              </p>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                {{ event.startDate | date:'h:mm a' }} - {{ event.endDate | date:'h:mm a' }}
              </p>
            </td>
            <td class="px-6 py-4">
              <p class="font-medium dark:text-gray-400">{{ event.clientName }}</p>
              @if (event.clientPhone) {
              <p class="text-xs text-gray-500 dark:text-gray-400">{{ event.clientPhone }}</p>
              }
              @if (event.clientEmail) {
              <p class="text-xs text-gray-500 dark:text-gray-400">{{ event.clientEmail }}</p>
              }
            </td>
            <td class="px-6 py-4">
              <p class="text-gray-700 dark:text-gray-400">{{ event.serviceName }}</p>
              @if (event.serviceDurationMinutes) {
              <p class="text-xs text-gray-500 dark:text-gray-400">
                {{ event.serviceDurationMinutes }} min
              </p>
              }
            </td>
            <td class="px-6 py-4">
              <p class="text-gray-700 dark:text-gray-400">
                {{ event.professionalName || 'Sin asignar' }}
              </p>
            </td>
            <td class="px-6 py-4">
              <span
                class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
                [ngClass]="getOriginBadgeClass(event.origin)">
                {{ getOriginLabel(event.origin) }}
              </span>
            </td>
            <td class="px-6 py-4">
              <span
                class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
                [ngClass]="getStatusBadgeClass(event.statusCode)">
                {{ getStatusLabel(event.statusCode) }}
              </span>
            </td>
          </tr>
          }
          }
        </tbody>
      </table>
    </div>
  </div>
</section>
